<era-device-scheduled-tasks-ui [scheduledTasks]="scheduledTasks()"
                               (deleteEvent)="delete($event)">
</era-device-scheduled-tasks-ui>